export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-6-b05788a0df98a04eb4b5b0bcf313501d.png";